@if (timeSlot$ | async; as slot) {
  <div class="layout-col full slot p-sm">
    <span>{{ getFormatted(slot.start) }} - {{ getFormatted(slot.end) }}</span>
    <span>&#64; {{ (slot.performance * 100).toFixed() }}%</span>
  </div>
}
